import { PERMISSIONS } from '@baboor/baboor-models'
import { NavigationItem } from './sidebar.model'

export const navigationItems: NavigationItem[] = [
    {
        label: 'Admin Dashboard',
        icon: 'pi-shield',
        routerLink: '/admin',
        superAdminOnly: true,
    },
    {
        label: 'Home',
        icon: 'pi-home',
        routerLink: '/dashboard/home',
    },
    {
        label: 'Calendar',
        icon: 'pi-calendar',
        routerLink: '/dashboard/calendar',
        permission: PERMISSIONS.calendar.read,
    },
    {
        label: 'Clients',
        icon: 'pi-users',
        routerLink: '/dashboard/clients',
        permission: PERMISSIONS.crm.read,
    },
    {
        label: 'Documents',
        icon: 'pi-file',
        routerLink: '/dashboard/documents',
        permission: PERMISSIONS.document.read,
    },
    // {
    //     label: 'Reports',
    //     icon: 'pi-flag',
    //     routerLink: '/dashboard/report',
    // },
    {
        label: 'Organization',
        icon: 'pi-building',
        routerLink: '/dashboard/organization',
        permission: PERMISSIONS.organization.read,
    },
    {
        label: 'Appointments',
        icon: 'pi-calendar-clock',
        routerLink: '/dashboard/appointments',
        permission: PERMISSIONS.appointment.read,
    },
    {
        label: 'Waitlist',
        icon: 'pi-users',
        routerLink: '/dashboard/waitlist',
        permission: PERMISSIONS.waitlist.read,
    },
    {
        label: 'Lookbook',
        icon: 'pi-images',
        routerLink: '/dashboard/lookbook',
        permission: PERMISSIONS.shop.read,
    },
    {
        label: 'Settings',
        icon: 'pi-cog',
        routerLink: '/dashboard/settings',
        permission: PERMISSIONS.settings.read,
    },
    {
        label: 'Feedback',
        icon: 'pi-comments',
        routerLink: '/dashboard/feedback',
    },
    {
        label: 'Referral',
        icon: 'pi-gift',
        routerLink: '/dashboard/referral',
        permission: PERMISSIONS.promotion.read,
    },
    // {
    //     label: 'Audit Log',
    //     icon: 'pi-database',
    //     routerLink: '/dashboard/audit-log',
    //     permission: PERMISSIONS.auditLog.read,
    // },
    // {
    //     label: 'Communication',
    //     icon: 'pi-envelope',
    //     routerLink: '/dashboard/communication',
    //     permission: PERMISSIONS.communication.read,
    // },
    // { label: 'Billing', icon: 'pi-wallet', routerLink: '/dashboard/billing', permission: 'billing:read' },
    // { label: 'Tasks', icon: 'pi-list-check', routerLink: '/dashboard/tasks', permission: PERMISSIONS.task.read },
    // {
    //     label: 'Communication',
    //     icon: 'pi-comments',
    //     routerLink: '/dashboard/chat',
    //     permission: PERMISSIONS.communication.read,
    // },
    // {
    //     label: 'Organizations',
    //     icon: 'pi-users',
    //     routerLink: '/dashboard/organizations',
    //     permission: PERMISSIONS.organization.read,
    // },
    // {
    //     label: 'Permissions',
    //     icon: 'pi-lock',
    //     routerLink: '/dashboard/permissions',
    //     permission: PERMISSIONS.role.read,
    // },
    // {
    //     label: 'Followed Cases',
    //     icon: 'pi-tag',
    //     routerLink: '/dashboard/followed-cases',
    //     permission: 'cases:read',
    // },
]
export const clientNavigationItems: NavigationItem[] = [
    {
        label: 'Home',
        icon: 'pi-home',
        routerLink: '/dashboard/home/client',
    },
    // {
    //     label: 'Cases',
    //     icon: 'pi-file-check',
    //     routerLink: '/dashboard/cases',
    //     permission: 'cases:read',
    // },
    {
        label: 'Calendar',
        icon: 'pi-calendar',
        routerLink: '/dashboard/client/calendar',
        permission: 'calendar:read',
    },

    // {
    //     label: 'Settings',
    //     icon: 'pi-cog',
    //     routerLink: '/dashboard/settings',
    //     permission: 'settings:read',
    // },
    // {
    //     label: 'Communication',
    //     icon: 'pi-comments',
    //     routerLink: 'dashboard/chat',
    //     permission: 'communication:read',
    // },
]
